import React from "react";

import { IIconRow } from "../../../interfaces";
import CmsMarkdown from "../../basic/cms-markdown";
import Icon from "../icon";

class IconRow extends React.Component<IIconRow> {
  render() {
    if (this.props == null) return <div></div>;
    const { icons, content, background_color, display_icon_labels } = this.props;
    const basisPercentage = 100 / icons.length;
    return (
      <div style={{ backgroundColor: background_color || "transparent" }} className="cms-icon-row">
        <div className="container-lg py-7 col-12 p-responsive">
          {content && <CmsMarkdown content={content} />}

          <div className="py-3 icon-row">
            {icons.map((icon) => (
              <Icon
                {...icon}
                key={icon.id}
                size={basisPercentage + "%"}
                name={display_icon_labels ? icon.name : ""}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default IconRow;
